export default __webpack_public_path__ + "static/media/botsfactory_logo_white.8244a75b.svg";